import { render } from "./CustomReport.vue?vue&type=template&id=2c72647a&scoped=true&ts=true"
import script from "./CustomReport.vue?vue&type=script&lang=ts"
export * from "./CustomReport.vue?vue&type=script&lang=ts"

import "./CustomReport.vue?vue&type=style&index=0&id=2c72647a&scoped=true&lang=css"
import "./CustomReport.vue?vue&type=style&index=1&id=2c72647a&lang=css"

import exportComponent from "/data/landun/workspace/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2c72647a"]])

export default __exports__